export const replaceFinalPathComponent = (path: string, newComponent: string) => {
    return path.replace(/\/[^\/]*$/, newComponent);
};
